document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".acc-content").forEach((el) => {
    el.style.display = "none";
  });

  document.querySelectorAll(".acc-header").forEach((header) => {
    header.addEventListener("click", function () {
      this.classList.toggle("active");

      const content = this.nextElementSibling;
      if (content.style.display === "none") {
        content.style.display = "block";
      } else {
        content.style.display = "none";
      }
    });
  });

  // variant selection & validation :
  document.addEventListener("change", function (e) {
    const form = e.target.closest(".corbusier-product-card");
    if (!form) return;

    const script = form.querySelector("script");
    if (!script) return;

    const productIdMatch = script.textContent.match(/productVariants_(\d+)/);
    if (!productIdMatch) return;

    const productId = productIdMatch[1];
    const variants = window["productVariants_" + productId];

    if (!variants) return;

    /* collect selected options dynamically */

    const selectedOptions = [];

    /* collect options in correct order */

    form.querySelectorAll("[data-option-position]").forEach((el) => {
      const position = parseInt(el.dataset.optionPosition) - 1;

      if (el.matches(".option-select")) {
        selectedOptions[position] = el.value;
      }
    });

    /* collect swatches */

    form.querySelectorAll(".swatchLi input:checked").forEach((input) => {
      const swatchDiv = input.closest(".swatchDiv");
      if (!swatchDiv) return;

      const select = swatchDiv.querySelector("[data-option-position]");
      if (!select) return;

      const position = parseInt(select.dataset.optionPosition) - 1;

      selectedOptions[position] = input.value;
    });

    /* find matching variant */

    let matchedVariant = variants.find((v) => {
      if (!v.options) return false;

      return v.options.every((opt, index) => opt === selectedOptions[index]);
    });

    if (!matchedVariant) return;

    /* update variant id for add to cart */

    const variantInput = form.querySelector("input[name='id']");
    if (variantInput) {
      variantInput.value = matchedVariant.id;
    }

    /* update price */

    const priceEl = form.querySelector(".totalprice");
    if (priceEl) {
      priceEl.textContent = matchedVariant.price;
    }

    /* update image */

    if (matchedVariant.image) {
      const img = form.querySelector(".boxImage img");
      if (img) {
        img.src = matchedVariant.image + "?v=" + Date.now();
      }
    }
  });

  // quantity box increment and decrement :
  document.addEventListener("click", function (e) {
    // PLUS
    if (e.target.closest(".is-plus")) {
      const form = e.target.closest(".corbusier-product-card");
      if (!form) return;

      const input = form.querySelector(".intBut");
      if (!input) return;

      let value = parseInt(input.value) || 1;
      input.value = value + 1;
    }

    // MINUS
    if (e.target.closest(".is-minus")) {
      const form = e.target.closest(".corbusier-product-card");
      if (!form) return;

      const input = form.querySelector(".intBut");
      if (!input) return;

      let value = parseInt(input.value) || 1;
      if (value > 1) {
        input.value = value - 1;
      }
    }
  });

  // change the color name on change :
  document.addEventListener("change", function (e) {
    const form = e.target.closest(".corbusier-product-card");
    if (!form) return;

    /* COLOR SWATCH */
    if (e.target.matches(".swatchLi input[type='radio']")) {
      const value = e.target.value;

      const swatchDiv = e.target.closest(".swatchDiv");
      if (!swatchDiv) return;

      const labelValue = swatchDiv.querySelector(".selected-option-value");

      if (labelValue) {
        labelValue.textContent = value;
      }
    }

    /* DROPDOWN OPTIONS */
    if (e.target.matches(".option-select")) {
      const value = e.target.value;

      const swatchDiv = e.target.closest(".swatchDiv");
      if (!swatchDiv) return;

      const labelValue = swatchDiv.querySelector(".selected-option-value");

      if (labelValue) {
        labelValue.textContent = value;
      }
    }
  });

  // ajax cart form submit :
  document.addEventListener("submit", function (e) {
    const form = e.target.closest(".corbusier-product-card");
    if (!form) return;

    e.preventDefault();

    const button = form.querySelector(".add-to-cart");

    if (button.classList.contains("loading")) return;

    const originalHTML = button.innerHTML;

    button.classList.add("loading");
    button.disabled = true;

    const formData = new FormData(form);

    formData.append(
      "sections",
      "cart-notification-product,cart-notification-button,cart-icon-bubble",
    );

    formData.append("sections_url", window.location.pathname);

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        const cartNotification = document.querySelector("cart-notification");

        if (cartNotification) {
          cartNotification.renderContents(data);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => {
        button.classList.remove("loading");
        button.disabled = false;
        button.innerHTML = originalHTML;
      });
  });
});
